/* Stanton builder: sections/wnf-stanton-builder.liquid. DOM contract and cart payload: release workspace research/dom-contract.md. */
(function () {
  'use strict';
  var root = document.querySelector('[data-wnfsb]');
  var cfgEl = document.getElementById('wnfsb-config');
  if (!root || !cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var GR = ['Standard', 'Premium', 'Performance'];
  var DATA = (window.WNFSB_DATA || {})[cfg.handle] || {};
  var FD = DATA.frames || {};
  var FAB = (window.STANTON_FABRICS || []).map(function (f) {
    return { name: f[0], handle: f[1], gi: f[2], grade: GR[f[2]] || 'Standard', color: f[3] || '' };
  });
  var FAB_BY = {};
  FAB.forEach(function (f) { FAB_BY[f.handle] = f; });
  var variants = cfg.variants || [];
  var frames = [];
  variants.forEach(function (v) { if (frames.indexOf(v.frame) < 0) frames.push(v.frame); });
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

  function variantFor(frame, grade) {
    for (var i = 0; i < variants.length; i++) if (variants[i].frame === frame && variants[i].grade === grade) return variants[i];
    return null;
  }
  function money(cents) {
    var n = Math.round(cents) / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function within(textL, needle) { return new RegExp('(^|[^a-z0-9])' + escRe(needle.toLowerCase()) + '([^a-z0-9]|$)').test(textL); }

  var state = { frame: frames.indexOf(cfg.defaultFrame) >= 0 ? cfg.defaultFrame : frames[0], grade: cfg.defaultGrade || 'Standard', fabric: null, facing: 'Right-Facing', wg: false, last: 'frame' };

  /* ---------- media: which photo shows which fabric and shape (from alt text) ---------- */
  var fabByLen = FAB.slice().sort(function (a, b) { return b.name.length - a.name.length; });
  var framesByLen = frames.slice().sort(function (a, b) { return b.length - a.length; });
  var media = (cfg.media || []).map(function (m) {
    var a = (m.alt || '').toLowerCase().replace(/custom sofa( \/ sectional)?|custom sectional|custom sofa/g, ' ');
    m.fabric = null; m.frame = null;
    for (var i = 0; i < fabByLen.length; i++) if (within(a, fabByLen[i].name)) { m.fabric = fabByLen[i].handle; break; }
    for (var j = 0; j < framesByLen.length; j++) if (within(a, framesByLen[j])) { m.frame = framesByLen[j]; break; }
    return m;
  });
  var MEDIA_BY_ID = {};
  media.forEach(function (m) { MEDIA_BY_ID[m.id] = m; });
  var framePhoto = {};
  frames.forEach(function (fr) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.frame === fr && v.mid && MEDIA_BY_ID[v.mid]) {
        framePhoto[fr] = MEDIA_BY_ID[v.mid]; framePhoto[fr].frame = fr;
        // Per-shape photos often carry a stock "in Vintage Moss" alt that does not match the photo, so never name their fabric.
        // The alt's fabric is only used to say which fabric the generated preview was made in (all 78 checked green on 2026-10-12).
        framePhoto[fr].altFabric = framePhoto[fr].fabric; framePhoto[fr].fabric = null; framePhoto[fr].isFramePhoto = true;
        break;
      }
    }
  });
  var photoFabrics = [];
  media.forEach(function (m) { if (m.fabric && !m.isFramePhoto && photoFabrics.indexOf(m.fabric) < 0) photoFabrics.push(m.fabric); });

  function pickPhoto() {
    var fp = framePhoto[state.frame] || null;
    var f = state.fabric;
    var fallback = fp || media[0] || null;
    if (!f) return { m: fallback, kind: 'frame' };
    var exact = null, anyFab = null;
    for (var i = 0; i < media.length; i++) {
      var m = media[i];
      if (m.fabric !== f.handle) continue;
      if (!anyFab) anyFab = m;
      if (m.frame === state.frame) { exact = m; break; }
    }
    if (exact) return { m: exact, kind: 'exact' };
    if (state.last === 'fabric' && anyFab) return { m: anyFab, kind: 'fabric' };
    if (fp) return { m: fp, kind: 'frame' };
    if (anyFab) return { m: anyFab, kind: 'fabric' };
    return { m: fallback, kind: 'frame' };
  }
  function captionFor(p) {
    var f = state.fabric, m = p.m;
    if (!m) return { main: state.frame, sub: '' };
    if (p.kind === 'exact') return { main: 'Shown in ' + f.name, sub: state.frame };
    if (p.kind === 'fabric') return { main: 'Shown in ' + f.name, sub: m.frame && m.frame !== state.frame ? 'Photo shows the ' + m.frame : '' };
    var af = m.altFabric && FAB_BY[m.altFabric];
    /* after a pick the caption names the shopper's fabric once (the price line names the chaise side) and says what the photo really shows */
    if (!f) return { main: state.frame + (af ? ' in ' + af.name + ' · ' + (af.gi ? deltaLabel(af.gi) : 'no extra cost') : ''), sub: 'Generated preview' };
    return { main: 'Your fabric: ' + f.name + ' · ' + (f.gi ? f.grade + ' ' + deltaLabel(f.gi) : 'included'), sub: af && af.handle === f.handle ? 'Generated preview in your fabric' : 'Photo: generated preview' + (af ? ' in ' + af.name : '') };
  }
  /* gallery: the builder view first, then the product's other photos (room, details, spec sheet) */
  var viewing = null;
  /* marketing graphics never show here: spec sheets, planners and the old "350+ fabrics" collage (the real count is 167).
     Most say so in their alt text; Nirvana's two do not, so they are listed by media id (checked 2026-10-12). */
  var NOT_PHOTO = /spec sheet|fabric options|configuration|dimension view|seating options/i, NOT_PHOTO_IDS = [30300521889950, 30277184389278];
  var extras = media.filter(function (m) { return !m.isFramePhoto && !NOT_PHOTO.test(m.alt || '') && NOT_PHOTO_IDS.indexOf(m.id) < 0; }).slice(0, 5);
  /* the generated shop-the-room photo (theme asset) leads the extra photos, captioned with its real fabric */
  var rooms = [cfg.room, cfg.room2].filter(function (r) { return r && r.src; });
  rooms.forEach(function (r, i) { r.isRoom = true; r.shop = i === 0; MEDIA_BY_ID[r.id] = r; });
  if (rooms.length) extras = rooms.concat(extras).slice(0, 5);
  /* the hero opens on the room photo when the builder has one (data-room-first); any shape or fabric pick switches to the builder view */
  var roomFirst = rooms.length && root.hasAttribute('data-room-first');
  if (roomFirst) viewing = rooms[0].id;
  function extraCaption(m) {
    var f = state.fabric, fab = m.fabric && FAB_BY[m.fabric];
    /* room photos name their fabric and what it adds to the price, and say the styled pieces are not included */
    if (fab && m.isRoom) return { main: 'Shown in ' + fab.name + ' · ' + (fab.gi ? deltaLabel(fab.gi) : 'no extra cost'), sub: 'Generated room · other pieces sold separately' };
    if (fab) return { main: 'Shown in ' + fab.name, sub: f && f.handle !== fab.handle ? 'Your fabric: ' + f.name : '' };
    /* product media alt texts are not reliable descriptions, so other photos get a neutral label */
    return { main: 'May show another fabric', sub: '' };
  }

  /* ---------- crossfading image layers (stage, summary thumb, phone bar thumb) ---------- */
  // The photo area takes the photo's own corner color, so studio shots on cream or white never show a box.
  function bgOf(img) {
    if (img.dataset.bg) return img.dataset.bg;
    try {
      var c = document.createElement('canvas'); c.width = c.height = 1;
      var x = c.getContext('2d'); x.drawImage(img, 0, 0, Math.max(1, img.naturalWidth * 0.04), Math.max(1, img.naturalHeight * 0.04), 0, 0, 1, 1);
      var d = x.getImageData(0, 0, 1, 1).data;
      // A transparent or not-yet-decoded pixel reads as (0,0,0,0): keep the CSS photo color instead of painting black.
      img.dataset.bg = d[3] > 250 ? 'rgb(' + d[0] + ',' + d[1] + ',' + d[2] + ')' : '';
    } catch (e) { img.dataset.bg = ''; }
    return img.dataset.bg;
  }
  function Area(el, sizes, thumb) { this.el = el; this.sizes = sizes; this.thumb = thumb; this.cache = {}; this.cur = null; this.want = null; }
  Area.prototype.layer = function (m) {
    if (!this.el || !m) return null;
    var img = this.cache[m.id];
    if (img) return img;
    img = document.createElement('img');
    img.setAttribute('data-wnfsb-img', '');
    img.setAttribute('data-mid', m.id);
    var alt = m.alt || '';
    /* shape previews: say they are generated and name the frame ("Grand Sofa in ..." becomes "Aspen Grand Sofa in ...") */
    if (m.isFramePhoto && alt) alt = 'Generated preview: ' + (alt.toLowerCase().indexOf(cfg.model.toLowerCase()) < 0 ? cfg.model + ' ' : '') + alt;
    img.alt = this.thumb ? '' : alt.replace(/\bWhats New\b/g, "What's New");
    img.decoding = 'async';
    /* a decorative area with sizes (the summary photo) still gets the full srcset; only the tiny phone bar thumb uses the 360px file */
    if (this.thumb && !this.sizes) img.src = m.thumb;
    else { img.sizes = this.sizes; img.srcset = m.srcset; img.src = m.src; }
    img.width = m.w; img.height = m.h;
    this.el.insertBefore(img, this.el.firstChild);
    this.cache[m.id] = img;
    return img;
  };
  Area.prototype.show = function (m) {
    if (!this.el || !m) return;
    var self = this, img = this.layer(m);
    this.want = m.id;
    if (img === this.cur) return;
    var go = function () {
      if (self.want !== m.id) return;
      Object.keys(self.cache).forEach(function (k) { self.cache[k].classList.toggle('is-on', self.cache[k] === img); });
      self.cur = img;
      var bg = bgOf(img); if (bg) self.el.style.backgroundColor = bg;
    };
    if (img.complete && img.naturalWidth) go();
    else if (img.decode) img.decode().then(go, go);
    else img.addEventListener('load', go, { once: true });
  };
  var stage = new Area($('[data-wnfsb-stage]'), '(max-width: 768px) 100vw, 56vw', false);
  var first = stage.el && stage.el.querySelector('img[data-wnfsb-img]');
  if (first) {
    var firstMedia = MEDIA_BY_ID[first.getAttribute('data-mid')] || framePhoto[state.frame] || media[0];
    if (firstMedia) { stage.cache[firstMedia.id] = first; stage.cur = first; first.setAttribute('data-mid', firstMedia.id); }
  }
  if (first) { var fbg = function () { var b = bgOf(first); if (b) stage.el.style.backgroundColor = b; }; if (first.complete && first.naturalWidth) fbg(); else first.addEventListener('load', fbg, { once: true }); }
  /* 2026-10-12 Hayden: "the studio image of the sofa looks blurry": the summary photo drew the 360px thumb at ~500px wide
     (cropped to 16:10, so up to 1,100 device px on a Retina screen); it now picks from the 600/900/1300 srcset (phones hide it: 120px keeps that download small) */
  var sumThumb = new Area($('[data-wnfsb-sum-thumb]'), '(min-width: 1024px) 44vw, (min-width: 769px) 50vw, 120px', true);
  var barThumb = new Area($('[data-wnfsb-bar-thumb]'), '', true);

  /* ---------- shape footprints (inches, drawn to one scale per product) ---------- */
  var maxL = 0, maxD = 0;
  frames.forEach(function (fr) { var d = FD[fr]; if (d) { maxL = Math.max(maxL, d.L); maxD = Math.max(maxD, d.D); } });
  var K = maxL ? Math.min(144 / maxL, 88 / maxD) : 1;
  function fitScale() {
    var fp = $('[data-wnfsb-fp]');
    var w = (fp && fp.clientWidth ? fp.clientWidth : 144) - 34, h = (fp && fp.clientHeight ? fp.clientHeight : 88) - 24; /* room for the size lines and labels */
    K = maxL ? Math.min(w / maxL, h / maxD) : 1;
  }
  /* width line under the shape and depth bracket beside it, each with its inches printed, so the drawing carries its size */
  function svgWrap(w, h, inner, d) {
    var y = h + 8, x = w + 8, f = function (n) { return n.toFixed(1); };
    var dim = '<g class="dim"><line x1="0" y1="' + f(y) + '" x2="' + f(w) + '" y2="' + f(y) + '"/><line x1="0" y1="' + f(y - 3) + '" x2="0" y2="' + f(y + 3) + '"/><line x1="' + f(w) + '" y1="' + f(y - 3) + '" x2="' + f(w) + '" y2="' + f(y + 3) + '"/>' +
      '<line x1="' + f(x) + '" y1="0" x2="' + f(x) + '" y2="' + f(h) + '"/><line x1="' + f(x - 3) + '" y1="0" x2="' + f(x + 3) + '" y2="0"/><line x1="' + f(x - 3) + '" y1="' + f(h) + '" x2="' + f(x + 3) + '" y2="' + f(h) + '"/></g>';
    var txt = d ? '<text class="dimt" x="' + f(w / 2) + '" y="' + f(y + 12) + '" text-anchor="middle">' + d.L + ' in</text><text class="dimt" x="' + f(x + 5) + '" y="' + f(h / 2 + 4) + '">' + d.D + ' in</text>' : '';
    return '<svg width="' + (w + 34).toFixed(0) + '" height="' + (h + 24).toFixed(0) + '" viewBox="-1.5 -1.5 ' + f(w + 37) + ' ' + f(h + 27) + '" role="img" aria-label="' + (d ? d.L + ' inches wide by ' + d.D + ' inches deep' : 'Shape') + '" focusable="false"><g class="shp">' + inner + '</g>' + dim + txt + '</svg>';
  }
  function footprint(fr) {
    var d = FD[fr];
    if (!d || !d.rects || !d.rects.length) return '';
    var w = d.L * K, h = d.D * K, back = DATA.backDepth || 38, s = '', fills = '', lines = '';
    if (d.poly && d.poly.length > 2) {
      var pts = d.poly.map(function (q) { return (q[0] * K).toFixed(1) + ',' + (q[1] * K).toFixed(1); }).join(' ');
      s = '<polygon class="o" points="' + pts + '"/>'; fills = '<polygon class="f" points="' + pts + '"/>';
      var by = Math.min(back, d.D) * 0.32 * K;
      lines = '<line class="b" x1="8" y1="' + by.toFixed(1) + '" x2="' + (w - 8).toFixed(1) + '" y2="' + by.toFixed(1) + '"/>';
      return svgWrap(w, h, s + fills + lines, d);
    }
    d.rects.forEach(function (r) {
      var x = r[0] * K, y = r[1] * K, rw = r[2] * K, rh = r[3] * K;
      s += '<rect class="o" x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + rw.toFixed(1) + '" height="' + rh.toFixed(1) + '" rx="6"/>';
      fills += '<rect class="f" x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + rw.toFixed(1) + '" height="' + rh.toFixed(1) + '" rx="6"/>';
      if (r[1] === 0) {
        var ly = Math.min(r[3], back) * 0.32 * K, inset = Math.min(rw * 0.08, 8);
        lines += '<line class="b" x1="' + (x + inset).toFixed(1) + '" y1="' + ly.toFixed(1) + '" x2="' + (x + rw - inset).toFixed(1) + '" y2="' + ly.toFixed(1) + '"/>';
      }
    });
    return svgWrap(w, h, s + fills + lines, d);
  }
  function drawFootprints() {
    fitScale();
    $$('[data-wnfsb-shape]').forEach(function (btn) { var fp = $('[data-wnfsb-fp]', btn); if (fp && FD[btn.getAttribute('data-wnfsb-shape')]) fp.innerHTML = footprint(btn.getAttribute('data-wnfsb-shape')); });
  }
  var fpW = 0;
  window.addEventListener('resize', function () { var fp = $('[data-wnfsb-fp]'); if (fp && Math.abs(fp.clientWidth - fpW) > 4) { fpW = fp.clientWidth; drawFootprints(); } });
  $$('[data-wnfsb-shape]').forEach(function (btn) {
    var fr = btn.getAttribute('data-wnfsb-shape'), d = FD[fr];
    var fp = $('[data-wnfsb-fp]', btn), len = $('[data-wnfsb-len]', btn), deep = $('[data-wnfsb-deep]', btn);
    var m = /(\d{2,3})\s*"/.exec(fr);
    if (len) len.textContent = d ? d.L + ' in wide' : (m ? m[1] + ' in wide' : '');
    if (deep) deep.textContent = ''; /* depth is printed on the drawing */
    if (!d && fp) fp.style.display = 'none';
  });
  drawFootprints();
  fpW = ($('[data-wnfsb-fp]') || {}).clientWidth || 0;

  var specEl = $('[data-wnfsb-specs]'), SP = DATA.specs || {};
  if (specEl) {
    var bits = [];
    if (SP.seatHeight) bits.push('Seat height ' + SP.seatHeight + ' in');
    if (SP.seatDepth) bits.push('seat depth ' + SP.seatDepth + ' in');
    if (SP.legs) bits.push(SP.legs);
    if (SP.back) bits.push(SP.back);
    /* fit is the biggest risk on a final-sale order, so the spec line ends with a way to ask */
    if (bits.length) specEl.innerHTML = bits.join(' · ') + ' · <a href="/pages/contact-us" data-wnfsb-chat>Will it fit? Ask\u00a0us</a>'; else specEl.hidden = true;
  }

  /* ---------- fabrics ---------- */
  var BUCKETS = [
    ['all', 'Our picks', function () { return true; }],
    ['green', 'Greens', function (f) { return f.color === 'Green'; }],
    ['neutral', 'Neutrals', function (f) { return /^(Cream|Tan|Gray|Brown)$/.test(f.color); }],
    ['blue', 'Blues', function (f) { return /^(Blue|Teal)$/.test(f.color); }],
    ['warm', 'Warm', function (f) { return /^(Yellow|Orange|Red|Pink|Purple)$/.test(f.color); }],
    ['dark', 'Darks', function (f) { return f.color === 'Black'; }],
    ['multi', 'Patterns', function (f) { return f.color === 'Multi'; }],
    ['perf', 'Performance', function (f) { return f.gi === 2; }]
  ].filter(function (b) { return b[0] === 'all' || FAB.some(b[2]); });
  var filter = 'all', libOpen = false, renderedFor = null;
  var curated = [];
  /* badged fabrics lead "Our picks" (Most ordered, then this frame's Popular choice), then fabrics with real photos, then house picks */
  var POPULAR = (cfg.popular || []).filter(function (h) { return h && h !== cfg.topPick; });
  [cfg.topPick].concat(POPULAR, photoFabrics, cfg.quickPicks || []).forEach(function (h) { if (h && FAB_BY[h] && curated.indexOf(h) < 0) curated.push(h); });
  curated = curated.slice(0, 15);

  function gradeDelta(gi) {
    var base = variantFor(state.frame, 'Standard'), v = variantFor(state.frame, GR[gi]);
    if (!base || !v) return null;
    return v.price - base.price;
  }
  function deltaLabel(gi) {
    if (gi === 0) return 'Included';
    var d = gradeDelta(gi);
    return d == null ? 'Not on this shape' : '+' + money(d);
  }
  function tile(f) {
    var on = state.fabric && state.fabric.handle === f.handle;
    return '<button type="button" class="wnfsb-sw' + (on ? ' is-on' : '') + '" data-wnfsb-fabric="' + f.handle + '" aria-pressed="' + (on ? 'true' : 'false') + '" aria-label="' + f.name + ', ' + f.grade + ', ' + deltaLabel(f.gi) + '">' +
      '<span class="wnfsb-sw__i"><img src="' + cfg.fabricCdn + f.handle + '.webp?width=240" alt="" loading="lazy" decoding="async" width="120" height="120">' +
      (f.handle === cfg.topPick ? '<span class="wnfsb-top">Most ordered</span>' : (POPULAR.indexOf(f.handle) > -1 ? '<span class="wnfsb-top wnfsb-top--pop">Popular choice</span>' : '')) + '</span>' +
      '<span class="wnfsb-sw__n">' + f.name + '</span><span class="wnfsb-sw__d">' + deltaLabel(f.gi) + '</span></button>';
  }
  var grid = $('[data-wnfsb-grid]'), lib = $('[data-wnfsb-library]'), flt = $('[data-wnfsb-filters]');
  function renderFilters() {
    if (!flt) return;
    flt.innerHTML = BUCKETS.map(function (b) {
      return '<button type="button" class="wnfsb-fchip' + (b[0] === filter ? ' is-on' : '') + '" data-wnfsb-filter="' + b[0] + '" aria-pressed="' + (b[0] === filter ? 'true' : 'false') + '">' + b[1] + '</button>';
    }).join('');
  }
  function renderGrid() {
    if (!grid) return;
    var list, bucket = BUCKETS.filter(function (b) { return b[0] === filter; })[0] || BUCKETS[0];
    if (filter === 'all') list = curated.map(function (h) { return FAB_BY[h]; });
    else list = FAB.filter(bucket[2]).sort(function (a, b) { return a.gi - b.gi || a.name.localeCompare(b.name); });
    var html = list.map(tile).join('');
    if (filter === 'all') html += '<button type="button" class="wnfsb-all" data-wnfsb-all aria-expanded="' + (libOpen ? 'true' : 'false') + '"><b>' + FAB.length + '</b>' + (libOpen ? 'Hide the full list' : 'See every fabric') + '</button>';
    grid.innerHTML = html;
    if (lib) {
      lib.hidden = !(libOpen && filter === 'all');
      if (!lib.hidden) {
        lib.innerHTML = [0, 1, 2].map(function (gi) {
          var fs = FAB.filter(function (f) { return f.gi === gi; }).sort(function (a, b) { return a.name.localeCompare(b.name); });
          if (!fs.length) return '';
          return '<p class="wnfsb-lib__h"><b>' + GR[gi] + ' · ' + fs.length + ' fabrics</b><span>' + deltaLabel(gi) + '</span></p><div class="wnfsb-lib__g">' + fs.map(tile).join('') + '</div>';
        }).join('');
      }
    }
    var note = $('[data-wnfsb-grade-note]');
    if (note) {
      var p = gradeDelta(1), q = gradeDelta(2);
      var nStd = FAB.filter(function (x) { return x.gi === 0; }).length;
      note.innerHTML = nStd + ' Standard fabrics are included' + (p != null ? '; Premium adds ' + money(p) : '') + (q != null ? ', Performance adds ' + money(q) : '') + '. Feel them at our Portland store, or <a href="/pages/contact-us" data-wnfsb-chat>chat with us</a> and we\'ll help you pick.';
    }
  }

  /* ---------- update everything from state ---------- */
  var hint = $('[data-wnfsb-hint]');
  function setHint(html) { if (!hint) return; if (html) { hint.innerHTML = html; hint.hidden = false; } else { hint.hidden = true; hint.innerHTML = ''; } }
  function addonCents() {
    return $$('input[data-wnfsb-addon]:checked').reduce(function (s, i) { return s + (parseInt(i.getAttribute('data-cents'), 10) || 0); }, 0);
  }
  var thumbsEl = $('[data-wnfsb-thumbs]');
  function renderThumbs(builderMedia) {
    if (!thumbsEl || !extras.length) return;
    var html = '';
    /* the hero strip is room photos only (studio shots and lifestyle photos do not mix); your shape joins it, first, once the stage
       shows it (a shape or fabric pick). Builders without room photos fall back to the product images. One photo: no strip. */
    var mine = { id: '', m: builderMedia, label: state.fabric ? 'Your ' + cfg.model : 'Shape preview' };
    var tile = function (m) { return { id: String(m.id), m: m, label: m.isRoom ? 'Room photo' : 'Product image', room: !!m.isRoom }; };
    var roomTiles = extras.filter(function (m) { return m.isRoom; }).map(tile);
    var list = roomTiles.length ? ((state.fabric || !viewing) ? [mine] : []).concat(roomTiles) : [mine].concat(extras.map(tile));
    list = list.filter(function (it) { return it.m; }).slice(0, 5);
    list.forEach(function (it) {
      if (!it.m) return;
      var on = (viewing || '') === it.id;
      html += '<button type="button" class="wnfsb-th' + (it.room ? ' is-room' : '') + (on ? ' is-on' : '') + '" data-wnfsb-th="' + it.id + '" aria-pressed="' + (on ? 'true' : 'false') + '" aria-label="' + it.label.replace(/"/g, '&quot;') + '"><img src="' + it.m.thumb + '" alt="" width="72" height="54" loading="lazy" decoding="async"></button>';
    });
    if (thumbsEl.innerHTML !== html) thumbsEl.innerHTML = html;
    thumbsEl.hidden = list.length < 2;
    if (stage.el) stage.el.classList.toggle('has-thumbs', list.length > 1);
  }
  function hasFacing() { return !!(FD[state.frame] && FD[state.frame].facing); }
  /* haul-away follows the shape: sectional rate for sectional shapes, sofa rate otherwise (rate card) */
  function syncRemoval() {
    var rm = $('[data-wnfsb-rm]'); if (!rm) return;
    var sect = /sectional/i.test(state.frame);
    rm.setAttribute('data-id', rm.getAttribute(sect ? 'data-sect-id' : 'data-sofa-id'));
    rm.setAttribute('data-cents', rm.getAttribute(sect ? 'data-sect-cents' : 'data-sofa-cents'));
    var n = $('[data-wnfsb-rm-noun]'); if (n) n.textContent = sect ? 'sectional' : 'sofa';
    var pr = $('[data-wnfsb-rm-price]'); if (pr) pr.textContent = '+' + money(parseInt(rm.getAttribute('data-cents'), 10) || 0);
  }
  function update() {
    syncRemoval();
    var v = variantFor(state.frame, state.grade);
    var f = state.fabric, total = (v ? v.price : 0) + addonCents();
    root.setAttribute('data-frame', state.frame);
    root.setAttribute('data-grade', state.grade);
    root.setAttribute('data-fabric', f ? f.handle : '');
    root.setAttribute('data-facing', hasFacing() ? state.facing : '');
    $$('[data-wnfsb-shape]').forEach(function (b) {
      var on = b.getAttribute('data-wnfsb-shape') === state.frame;
      b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
    });
    var fr = $('[data-wnfsb-facing-row]');
    if (fr) fr.hidden = !hasFacing();
    $$('[data-wnfsb-facing]').forEach(function (b) {
      var on = b.getAttribute('data-wnfsb-facing') === state.facing;
      b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
    });
    var d = FD[state.frame];
    var side = hasFacing() ? (state.facing === 'Left-Facing' ? 'left' : 'right') + ' chaise' : '';
    var shapeTxt = state.frame + (side ? ', ' + side : '') + (d ? ' · ' + d.L + '\u00a0×\u00a0' + d.D + '\u00a0in' : '');
    var sl = $('[data-wnfsb-shape-label]'); if (sl) sl.textContent = shapeTxt;
    var fabTxt = f ? f.name + ' · ' + f.grade + (f.gi ? '\u00a0' + deltaLabel(f.gi) : ', included') : '';
    var fl = $('[data-wnfsb-fabric-label]'); if (fl) fl.textContent = fabTxt;
    /* before a fabric is picked the price is the shape's starting price, so say "From" (matches the hero) */
    var priceTxt = v ? (f ? '' : 'From ') + money(total) : 'Not offered';
    var priceHtml = v ? (f ? '' : '<small>From</small> ') + money(total) : 'Not offered';
    $$('[data-wnfsb-price]').forEach(function (el) { el.innerHTML = priceHtml; });
    var bp = $('[data-wnfsb-bar-price]'); if (bp) bp.innerHTML = priceHtml;
    /* the summary says what you are buying and why the price is what it is: shape, side, fabric with its grade cost, add-ons */
    var AO_SHORT = { fp: 'Protection', wg: 'White Glove', removal: 'Haul-away' };
    var aoTxt = $$('input[data-wnfsb-addon]:checked').map(function (i) { return (AO_SHORT[i.getAttribute('data-wnfsb-addon')] || 'Add-on') + ' ' + money(parseInt(i.getAttribute('data-cents'), 10) || 0); });
    var nStdF = FAB.filter(function (x) { return x.gi === 0; }).length;
    var line = [state.frame + (side ? ', ' + side : ''), f ? f.name + ', ' + (f.gi ? f.grade + '\u00a0' + deltaLabel(f.gi) : f.grade + ' included') : 'any of ' + nStdF + ' fabrics at this price'].join(' · ');
    var sline = $('[data-wnfsb-sum-line]'); if (sline) sline.textContent = line;
    /* the phone bar names the configuration (the chaise side is preselected, so it stays in view) */
    var Side = side ? side.charAt(0).toUpperCase() + side.slice(1) : '';
    var bl1 = f ? (Side ? Side + ' · ' : '') + f.name : (Side || state.frame), bl2 = f ? 'Made in Oregon · final sale' : (Side ? state.frame : 'Made in Oregon');
    var bline = $('[data-wnfsb-bar-line]');
    if (bline) { bline.textContent = ''; [bl1, bl2].forEach(function (t) { var sp = document.createElement('span'); sp.className = 'wnfsb-bar__l'; sp.textContent = t; bline.appendChild(sp); }); }
    var sg = $('[data-wnfsb-sum-grade]');
    if (sg) { var dl = f ? (f.gi ? ' +' + money(gradeDelta(f.gi) || 0) : ' (included)') : ''; sg.textContent = f ? f.name + ' · ' + f.grade + dl : 'Choose a fabric'; }
    /* hero price is the starting price of the shape in the photo, so it always matches what is shown */
    var shownMin = null; variants.forEach(function (x) { if (x.frame === state.frame && (shownMin === null || x.price < shownMin)) shownMin = x.price; });
    /* once a fabric is picked the hero shows the real price of that shape and fabric, same as the summary */
    var hp = $('[data-wnfsb-hero-price]'); if (hp) { if (f && v) hp.textContent = money(v.price); else if (shownMin !== null) hp.textContent = 'From ' + money(shownMin); }
    /* after a pick the hero names the chaise side; the photo caption names the fabric */
    var hs = $('[data-wnfsb-hero-shape]');
    if (hs) {
      hs.textContent = state.frame;
      if (f && v && hasFacing()) { var hd = document.createElement('span'); hd.className = 'wnfsb-hs-side'; hd.textContent = (state.facing === 'Left-Facing' ? 'left' : 'right') + ' chaise'; hs.appendChild(hd); }
    }
    /* the cheaper-shape line and the fabric count step aside once a fabric is picked: the hero then shows one exact price */
    var pa = $('.wnfsb-prow__alt'); if (pa) pa.hidden = !!f || state.frame !== cfg.defaultFrame;
    var fl2 = $('.wnfsb-fabs'); if (fl2) fl2.hidden = !!f;
    /* once a fabric is picked the hero button finishes the order instead of starting it */
    var sb = $('[data-wnfsb-start]'); if (sb) { sb.textContent = f ? 'Finish your ' + cfg.model : 'Design yours'; sb.setAttribute('href', f ? '#wnfsb-sum' : '#wnfsb-build'); }
    var tier = total >= 500000 ? 'oregon' : (total >= 150000 ? 'local' : 'under');
    $$('[data-wnfsb-deliv] [data-wnf-deliv-tier]').forEach(function (s) { s.hidden = s.getAttribute('data-wnf-deliv-tier') !== tier; });
    var atcTxt = !f ? 'Choose fabric' : (!v || !v.available ? 'Not offered in this grade' : 'Add to cart · ' + money(total));
    var atc = $('[data-wnfsb-atc]'); if (atc && !atc.disabled) { atc.textContent = atcTxt; atc.setAttribute('aria-disabled', f && v && v.available ? 'false' : 'true'); }
    var batc = $('[data-wnfsb-bar-atc]'); if (batc && !batc.disabled) batc.textContent = !f ? 'Choose fabric' : 'Add to cart';
    if (f && v && v.available) setHint('');
    else if (f && (!v || !v.available)) setHint(f.name + ' is ' + f.grade + ' grade, which this shape does not come in. Pick another fabric or shape.');
    if (renderedFor !== state.frame) { renderGrid(); renderedFor = state.frame; }
    else $$('[data-wnfsb-fabric]').forEach(function (b) { var on = !!f && b.getAttribute('data-wnfsb-fabric') === f.handle; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var p = pickPhoto(), c = captionFor(p);
    if (p.m) sumThumb.show(p.m);
    var bt = $('[data-wnfsb-bar-thumb]');
    if (bt && bt.getAttribute('data-fr') !== state.frame) {
      var bsw = bt.querySelector('[data-wnfsb-bar-sw]');
      bt.innerHTML = '<span class="wnfsb-bar__fp" aria-hidden="true">' + footprint(state.frame) + '</span>';
      if (bsw) bt.appendChild(bsw);
      bt.setAttribute('data-fr', state.frame);
    }
    /* the summary photo says what it shows (a generated preview, often in another fabric) */
    var sc = $('[data-wnfsb-sum-cap]'); if (sc) { var saf = p.m && p.m.altFabric && FAB_BY[p.m.altFabric]; sc.textContent = p.kind === 'frame' ? 'Photo: generated preview' + (saf ? ' in ' + saf.name : '') : (captionFor(p).main || ''); }
    var vm = viewing && MEDIA_BY_ID[viewing];
    if (vm) { stage.show(vm); c = extraCaption(vm); } else if (p.m) stage.show(p.m);
    if (stage.el) { stage.el.classList.toggle('is-extra', !!vm); stage.el.classList.toggle('is-room', !!(vm && vm.isRoom)); }
    renderThumbs(p.m);
    var addC = addonCents(), tl = $('[data-wnfsb-total-lbl]'), al = $('[data-wnfsb-addline]');
    if (tl) tl.textContent = addC ? 'Total with add-ons' : '';
    if (al) { al.hidden = !addC || !v; if (addC && v) al.textContent = [cfg.model + ' ' + money(v.price)].concat(aoTxt).join(' + '); }
    var cap = $('[data-wnfsb-caption]'), sub = $('[data-wnfsb-caption-sub]');
    if (cap) cap.textContent = c.main;
    var capBox = $('.wnfsb-cap'); if (capBox) capBox.hidden = !p.m && !vm;
    if (sub) { sub.textContent = c.sub; if (c.subLink) { var a = document.createElement('a'); a.href = '#wnfsb-room'; a.textContent = c.subLink; sub.appendChild(a); } }
    var swUrl = f ? cfg.fabricCdn + f.handle + '.webp?width=160' : '';
    ['[data-wnfsb-cap-sw]', '[data-wnfsb-sum-sw]', '[data-wnfsb-bar-sw]', '[data-wnfsb-row-sw]'].forEach(function (sel) {
      var im = $(sel); if (!im) return;
      var u = swUrl;
      /* the photo caption's swatch is the fabric in that photo (room, product image or generated preview), never assumed to be the pick */
      if (sel === '[data-wnfsb-cap-sw]') {
        var cf = vm ? vm.fabric : (f ? f.handle : p.m && p.m.altFabric);
        u = cf && FAB_BY[cf] ? cfg.fabricCdn + cf + '.webp?width=160' : '';
      }
      if (u) { if (im.getAttribute('src') !== u) im.src = u; im.hidden = false; } else im.hidden = true;
    });
    window.WNFSB.state = { frame: state.frame, grade: state.grade, fabric: f ? f.handle : null, facing: hasFacing() ? state.facing : null, wg: state.wg };
    try { root.dispatchEvent(new CustomEvent('wnfsb:change', { detail: window.WNFSB.state })); } catch (e) {}
  }
  window.WNFSB = { state: {}, variants: variants, variantFor: variantFor };

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wnfsb-shape],[data-wnfsb-fabric],[data-wnfsb-filter],[data-wnfsb-all],[data-wnfsb-facing],[data-wnfsb-atc],[data-wnfsb-bar-atc],[data-wnfsb-chat],[data-wnfsb-th]');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-wnfsb-th')) { viewing = t.getAttribute('data-wnfsb-th') || null; update(); return; }
    if (t.hasAttribute('data-wnfsb-shape') || t.hasAttribute('data-wnfsb-fabric') || t.hasAttribute('data-wnfsb-facing')) viewing = null;
    if (t.hasAttribute('data-wnfsb-shape')) { state.frame = t.getAttribute('data-wnfsb-shape'); state.last = 'frame'; update(); return; }
    if (t.hasAttribute('data-wnfsb-fabric')) {
      var f = FAB_BY[t.getAttribute('data-wnfsb-fabric')]; if (!f) return;
      state.fabric = f; state.grade = f.grade; state.last = 'fabric'; update();
      return;
    }
    if (t.hasAttribute('data-wnfsb-filter')) { filter = t.getAttribute('data-wnfsb-filter'); renderFilters(); renderGrid(); return; }
    if (t.hasAttribute('data-wnfsb-all')) { libOpen = !libOpen; renderGrid(); if (!libOpen) { var g = $('#wnfsb-fabric'); if (g) g.scrollIntoView({ block: 'start' }); } return; }
    if (t.hasAttribute('data-wnfsb-facing')) { state.facing = t.getAttribute('data-wnfsb-facing'); state.last = 'frame'; update(); return; }
    if (t.hasAttribute('data-wnfsb-atc') || t.hasAttribute('data-wnfsb-bar-atc')) { addToCart(t); return; }
    if (t.hasAttribute('data-wnfsb-chat') && typeof window.WNFChatOpen === 'function') { e.preventDefault(); window.WNFChatOpen(); }
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('input[data-wnfsb-addon]')) { if (e.target.getAttribute('data-wnfsb-addon') === 'wg') state.wg = e.target.checked; update(); }
  });
  function roving(groupSel, itemSel, attr, onPick) {
    root.addEventListener('keydown', function (e) {
      var t = e.target; if (!t.matches || !t.matches(itemSel)) return;
      var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      if (!(e.key in keys)) return;
      e.preventDefault();
      var items = $$(itemSel, t.closest(groupSel)), i = items.indexOf(t), n = items[(i + keys[e.key] + items.length) % items.length];
      onPick(n.getAttribute(attr)); n.focus();
    });
  }
  roving('[data-wnfsb-shapes]', '[data-wnfsb-shape]', 'data-wnfsb-shape', function (v) { state.frame = v; state.last = 'frame'; update(); });
  roving('.wnfsb-facing__btns', '[data-wnfsb-facing]', 'data-wnfsb-facing', function (v) { state.facing = v; update(); });

  /* ---------- swipe the stage on phones: next or previous photo, in the same order as the thumbnails ---------- */
  if (stage.el && thumbsEl) {
    var sx = null, sy = 0;
    stage.el.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; } else sx = null; }, { passive: true });
    stage.el.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var tt = e.changedTouches[0], dx = tt.clientX - sx, dy = tt.clientY - sy; sx = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var ids = $$('[data-wnfsb-th]', thumbsEl).map(function (b) { return b.getAttribute('data-wnfsb-th'); });
      var cur = Math.max(0, ids.indexOf(viewing || '')), next = cur + (dx < 0 ? 1 : -1);
      if (next < 0 || next >= ids.length) return;
      viewing = ids[next] || null; update();
    }, { passive: true });
  }

  /* ---------- shop the room: hovering or focusing a number lights its product card, and the reverse ---------- */
  function lightSpot(n) {
    $$('[data-wnfsb-spot]').forEach(function (d) { d.classList.toggle('is-on', d.getAttribute('data-wnfsb-spot') === n); });
    $$('[data-wnfsb-spot-card]').forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-wnfsb-spot-card') === n); });
  }
  ['mouseover', 'focusin'].forEach(function (ev) {
    root.addEventListener(ev, function (e) {
      var d = e.target.closest && e.target.closest('[data-wnfsb-spot],[data-wnfsb-spot-card]');
      if (d) lightSpot(d.getAttribute('data-wnfsb-spot') || d.getAttribute('data-wnfsb-spot-card'));
    });
  });

  /* ---------- add to cart (same payload as main-product-stanton-custom.liquid) ---------- */
  var busy = false;
  function addToCart(btn) {
    var v = variantFor(state.frame, state.grade);
    if (!state.fabric) {
      setHint('Choose a fabric first. Tap any swatch to see it and its price.');
      var g = $('#wnfsb-fabric'); if (g) g.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      var firstSw = $('[data-wnfsb-fabric]'); if (firstSw) setTimeout(function () { firstSw.focus({ preventScroll: true }); }, 400);
      return;
    }
    if (!v || !v.available) { setHint(state.fabric.name + ' is ' + state.fabric.grade + ' grade, which this shape does not come in. Pick another fabric or shape.'); return; }
    if (busy) return;
    busy = true;
    var btns = [$('[data-wnfsb-atc]'), $('[data-wnfsb-bar-atc]')].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
    var props = { 'Fabric': state.fabric.name, 'Frame': state.frame, 'Grade': state.grade, '_fabric_handle': state.fabric.handle };
    if (hasFacing()) props['Chaise Facing'] = state.facing;
    var items = [{ id: v.id, quantity: 1, properties: props }];
    /* Protection and White Glove name the sofa they are for, like the standard PDP (wnf-cart-item-link-2026-10-03):
       "For" shows on the cart line, checkout and the order; _wnf_for lets the cart keep the add-on under its sofa. */
    $$('input[data-wnfsb-addon]:checked').forEach(function (inp) {
      var id = parseInt(inp.getAttribute('data-id'), 10);
      if (!id) return;
      var it = { id: id, quantity: 1 };
      if (inp.hasAttribute('data-link')) it.properties = { For: cfg.title || cfg.model, _wnf_for: String(v.id) };
      items.push(it);
    });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function () {
        btns.forEach(function (b) { b.textContent = 'Added. Opening your cart…'; });
        setTimeout(function () { window.location.href = '/cart'; }, 500);
        setTimeout(function () { busy = false; btns.forEach(function (b) { b.disabled = false; }); update(); }, 4000);
      })
      .catch(function () {
        busy = false;
        btns.forEach(function (b) { b.disabled = false; });
        update();
        setHint('We could not confirm the cart update. <a href="/cart">Check your cart</a>, then try again.');
      });
  }

  /* ---------- phone bottom bar: shows once the hero button is gone, hides near the main Add to Cart and the closing band ---------- */
  var bar = $('[data-wnfsb-bar]');
  if (bar) {
    var startEl = $('[data-wnfsb-start]'), atcEl = $('[data-wnfsb-atc]'), closeEl = $('[data-wnfsb-close]'), sumEl = $('#wnfsb-sum'), raf = 0;
    var inView = function (el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; };
    var syncBar = function () {
      raf = 0;
      var sr = startEl ? startEl.getBoundingClientRect() : null;
      var gone = sr ? (sr.bottom < 0 || (window.scrollY > 160 && !inView(startEl))) : window.scrollY > 400;
      /* the summary card carries its own price and Add to cart, so the bar steps aside while it is on screen */
      var on = window.matchMedia('(max-width: 768px)').matches && gone && !inView(atcEl) && !inView(closeEl);
      if (on === bar.classList.contains('is-on')) return;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var b = $('[data-wnfsb-bar-atc]'); if (b) b.tabIndex = on ? 0 : -1;
    };
    var onScroll = function () { if (!raf) raf = (window.requestAnimationFrame || setTimeout)(syncBar, 16); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    syncBar();
  }

  /* ---------- preload lead photos at idle so a switch never shows a blank frame ---------- */
  function preload() {
    var list = [];
    frames.forEach(function (fr) { if (framePhoto[fr]) list.push(framePhoto[fr]); });
    media.forEach(function (m) { if (m.fabric && list.indexOf(m) < 0) list.push(m); });
    list.slice(0, 18).forEach(function (m) { var img = stage.layer(m); if (img) { try { img.fetchPriority = 'low'; } catch (e) {} if (img.decode) img.decode().catch(function () {}); } });
  }
  // Start only after the page (and the hero photo) has loaded, so the extra photos never compete with the first paint.
  var idle = function () { (window.requestIdleCallback || function (cb) { return setTimeout(cb, 600); })(preload, { timeout: 3000 }); };
  if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });

  renderFilters();
  update();
})();
